import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareNavItem } from '../../fragments/generated/ShareNavItem';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetSharesForProjectNavigationQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  orderBy?: Types.InputMaybe<Array<Types.ShareOrderInput>>;
  filters?: Types.InputMaybe<Types.ShareFiltersInput>;
}>;


export type GetSharesForProjectNavigationQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, shares?: { __typename?: 'ShareConnection', totalCount: number, nodes: Array<{ __typename?: 'AdHocAssetsShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, url?: string | null, useOriginHeader: boolean, creator: { __typename?: 'AuthenticatedUser', id: string }, thumbnailAssets?: Array<{ __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null, filetype?: string | null, hasAlpha?: boolean | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null } | null> | null } | { __typename?: 'CollectionShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, url?: string | null, useOriginHeader: boolean, creator: { __typename?: 'AuthenticatedUser', id: string }, thumbnailAssets?: Array<{ __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null, filetype?: string | null, hasAlpha?: boolean | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null } | null> | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null };


export const GetSharesForProjectNavigation = /*#__PURE__*/ gql`
    query GetSharesForProjectNavigation($projectId: ID!, $page: PageInput!, $orderBy: [ShareOrderInput!], $filters: ShareFiltersInput) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      shares(page: $page, orderBy: $orderBy, filters: $filters) {
        nodes {
          ...ShareNavItem
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  }
}
    ${ShareNavItem}` as unknown as DocumentNode<GetSharesForProjectNavigationQuery, GetSharesForProjectNavigationQueryVariables>;

          

          export const useGetSharesForProjectNavigationQuery = (options?:QueryHookOptions<GetSharesForProjectNavigationQuery, GetSharesForProjectNavigationQueryVariables>) => useQuery(GetSharesForProjectNavigation, options);

          

          export type GetSharesForProjectNavigationQueryOptions = QueryHookOptions<GetSharesForProjectNavigationQuery, GetSharesForProjectNavigationQueryVariables>;

          

          export const useGetSharesForProjectNavigationLazyQuery = (options?:LazyQueryHookOptions<GetSharesForProjectNavigationQuery, GetSharesForProjectNavigationQueryVariables>) => useLazyQuery(GetSharesForProjectNavigation, options);

          

          export type GetSharesForProjectNavigationQueryResult = ReturnType<typeof useGetSharesForProjectNavigationQuery>;

          
